import { FC, ReactNode } from "react";
import { useMessages } from "../../context/i18n";
import { trial as enTrial } from "../../dictionaries/en/trial";
import Typography from "../Typography";
import VideoInput from "../VideoInput";

type FinalCTAProps = {
  h2: ReactNode;
  subhead: ReactNode;
  videoInputPlaceholder?: string;
};

// Bottom-of-page conversion surface — mirror of the Hero VideoInput
// for visitors who scrolled the full page and were convinced by the
// content. Required on every v2 tool page per master spec
// §"Universal page structure".
const FinalCTA: FC<FinalCTAProps> = ({ h2, subhead, videoInputPlaceholder }) => {
  const trial = useMessages("trial", enTrial);
  return (
    <section className="text-center text-slate-950 flex flex-col items-center max-w-5xl mx-auto px-3 my-32 md:my-48">
      <Typography variant="h2" component="h2" className="max-w-3xl mx-auto">
        {h2}
      </Typography>
      <Typography variant="body1" className="mt-6 text-slate-600 max-w-2xl">
        {subhead}
      </Typography>
      <VideoInput
        placeholderText={videoInputPlaceholder}
        className="mt-10 w-full shadow-2xl max-w-xl mx-auto"
      />
      <Typography variant="caption" className="text-slate-500 mt-4">
        {trial.cta}
      </Typography>
    </section>
  );
};

export default FinalCTA;
